import { Link, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Layers, Newspaper, Quote, Users, Megaphone, Building2, Inbox, Settings, LogOut, ExternalLink } from "lucide-react";
import { Toaster } from "sonner";
import { useAuth } from "@/lib/auth";
import BrandMark from "@/components/site/BrandMark";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/case-studies", label: "Case Studies", icon: FileText },
  { to: "/admin/services", label: "Services", icon: Layers },
  { to: "/admin/posts", label: "Blog Posts", icon: Newspaper },
  { to: "/admin/testimonials", label: "Testimonials", icon: Quote },
  { to: "/admin/team", label: "Team", icon: Users },
  { to: "/admin/media", label: "Media", icon: Megaphone },
  { to: "/admin/clients", label: "Client Logos", icon: Building2 },
  { to: "/admin/redirects", label: "Redirects", icon: ExternalLink },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/settings", label: "Site Settings", icon: Settings },
];

export default function AdminShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div data-testid="admin-shell" className="min-h-screen bg-paper font-sans text-obsidian">
      <Toaster richColors position="top-center" />
      <aside className="fixed inset-y-0 left-0 z-30 flex w-60 flex-col bg-obsidian text-paper">
        <div className="border-b border-paper/10 px-6 py-6">
          <Link to="/admin" className="inline-flex items-center">
            <BrandMark footer linkTo={false} />
          </Link>
          <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.25em] text-paper/40">Admin CMS</p>
        </div>
        <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4" aria-label="Admin">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-[13px] font-semibold transition-colors ${
                  isActive ? "bg-paper/10 text-paper" : "text-paper/60 hover:text-paper"
                }`
              }
            >
              <n.icon size={15} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-paper/10 p-4">
          <p className="px-2 text-[11px] text-paper/50">{user?.email}</p>
          <div className="mt-3 flex gap-2 px-2">
            <a href="/" target="_blank" rel="noreferrer" className="text-[12px] font-semibold text-paper/70 hover:text-progress">
              View site ↗
            </a>
            <button data-testid="admin-logout" onClick={doLogout} className="ml-auto inline-flex items-center gap-1.5 text-[12px] font-semibold text-paper/70 hover:text-progress">
              <LogOut size={13} /> Log out
            </button>
          </div>
        </div>
      </aside>
      <main className="ml-0 min-h-screen px-5 py-10 lg:ml-60 lg:px-10">{children}</main>
    </div>
  );
}
